import { render, staticRenderFns } from "./myshop-add-or-update.vue?vue&type=template&id=23b0331a&"
import script from "./myshop-add-or-update.vue?vue&type=script&lang=js&"
export * from "./myshop-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports